import ReactWizard from '@shoutout-labs/reactbootstrap-wizard-rb';

export default ReactWizard;